import { Col, Divider, Row, Select } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactSVG } from "react-svg";
import alertCircle from "src/shared/assets/images/landing/alert-circle.svg";
import clock from "src/shared/assets/images/landing/clock.svg";
import lock from "src/shared/assets/images/landing/lock.svg";
import userCheck from "src/shared/assets/images/landing/user-check.svg";
import { ButtonC } from "src/shared/components";
import "./instaStructure.less";

interface InstaStructure {
  svg: string;
  h3?: string;
  p?: string;
  h4?: string;
  color: 1 | 2;
  id?: string;
  data?: any;
  ref?: any;
}
const InstaStructure = (props: InstaStructure) => {
  const { svg, color, h3, h4, p, data, id, ref } = props;
  const bg = color == 1 ? "bg" : "";
  const {
    location: { pathname },
  } = useHistory();
  const [state, setstate] = useState<any>();
  return (
    <section
      id={id}
      ref={ref}
      className={`instaStructure ${color == 1 ? "bg-second" : "bg-white"}`}
    >
      <Row justify="center" className="h100" align="middle">
        <Col xs={23} lg={20}>
          <Row justify="space-between" align="middle" gutter={[25, 25]}>
            <Col xs={23} md={21} lg={12} className="right">
              <div className="div-img">
                <ReactSVG src={svg} />
              </div>
              <h3>{h3}</h3>
              <p>{p}</p>
            </Col>
            <Col xs={23} md={21} lg={12} xl={9} className="left">
              <div className={`card ${color == 1 ? "bg-white" : "bg-second"}`}>
                <h4 style={{ color: "black" }}>{h4}</h4>
                <p style={{ color: "black" }}>
                  لطفا از منوی زیر تعداد مورد نظر را انتخاب کنید
                </p>
                <Select placeholder="انتخاب کنید" onChange={(e) => setstate(e)}>
                  {data?.map((item: any) => (
                    <Select.Option value={item.id}>
                      {item.quantity}
                    </Select.Option>
                  ))}
                </Select>
                <Divider />
                <div className="feature">
                  <ReactSVG src={lock} className="svg" />
                  <span style={{ color: "black" }}>بدون نیاز به پسورد شما</span>
                </div>
                <div className="feature">
                  <ReactSVG src={userCheck} className="svg" />
                  <span style={{ color: "black" }}>فالوور حقیقی</span>
                </div>
                <div className="feature">
                  <ReactSVG src={clock} className="svg" />
                  <span style={{ color: "black" }}>شروع فوری بعد از سفارش</span>
                </div>
                <div className="feature">
                  <ReactSVG src={alertCircle} className="svg" />
                  <span style={{ color: "black" }}>
                    کاملا بی خطر برای پیج شما
                  </span>
                </div>
                <Divider />
                <Row className="ordr-btn-div" justify="center">
                  <Col xs={20} md={18} lg={14}>
                    <ButtonC
                      block
                      onClick={() =>
                        window.location.replace(
                          `https://my.${window.location.host}/public/checkout?productId=${state}`
                        )
                      }
                      disabled={!state}
                    >
                      سفارش
                    </ButtonC>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default InstaStructure;
